import { ReactNode } from 'react';
import { FeatureRawResult } from '@packages/shared/core/feature-flags/entities';
import { useFeatureRawResult } from '@packages/shared/core/feature-flags/hooks';

type FeatureProps = {
  children: (result: FeatureRawResult) => ReactNode;
  name: string;
};

export const Feature = ({ children, name }: FeatureProps) => {
  const rawResult = useFeatureRawResult(name);

  return <>{children(rawResult)}</>;
};

export default Feature;
